module.exports = __webpack_public_path__ + "img/prepare-remove-btn.f52ad221.svg";